import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';
import {
    CreateInventoryTagInput,
    CreateInventoryTagResponse,
} from '../../types/inventory';

const createInventoryTag = async (
    sessionId: string,
    input: CreateInventoryTagInput,
): Promise<CreateInventoryTagResponse> => {
    const { data } = await axios.post(`${API_URL}/inventory/tags/create`, input, {
        headers: { Authorization: sessionId },
    });
    return data;
};

export const useCreateInventoryTag = (
    options?: UseMutationOptions<
        CreateInventoryTagResponse,
        unknown,
        CreateInventoryTagInput
    >,
) => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (input: CreateInventoryTagInput) =>
            createInventoryTag(sessionContext?.sessionId ?? '', input),
        ...options,
    });
};
